import React,{Component} from 'react';
import {formatPrice,formatQuantity} from '../helpers/helpers'

class QMiscellaneousViewPrint extends Component{    

    render() {  
            
        return (
                <tr>
                    <td className="pName">{this.props.product.productName}</td>
                    <td className="pDimension">{this.props.product.productDimension}</td>  

                    <td className="pQtyPUnit">{formatQuantity(this.props.product.productNumber)}</td>                    
                    <td className="unitAlone">{this.props.product.productUnit}</td>

                    <td className="pPricePunit">{formatPrice(this.props.product.productPrice)}</td>                    
                    <td className="priceUnitAlone">/{this.props.product.productUnit}</td>

                    <td className="pDisc">{this.props.product.productDiscount}%</td>
                    <td className="pAmount">{formatPrice(this.props.product.productTotal)}</td>

                </tr>

                    
 
        );
    }
}

export default  QMiscellaneousViewPrint;


// WEBPACK FOOTER //
// ./src/components/QMiscellaneousViewPrint.js